import { GemSalesConfig } from "./types";

type ThemeKey = keyof GemSalesConfig["theme"];

const TOKEN_SOURCES: Array<[ThemeKey, string[]]> = [
  ["primaryColor", ["--gem-color-primary", "--gemforge-primary", "--wn-primary", "--color-primary", "--color-button"]],
  ["primaryHoverColor", ["--gem-color-primary-hover", "--gemforge-primary-dark", "--wn-primary-dark"]],
  ["primaryTintColor", ["--gem-color-primary-tint", "--gemforge-bg-primary"]],
  ["textColor", ["--gem-color-text", "--gemforge-text", "--wn-text", "--color-foreground"]],
  ["mutedTextColor", ["--gem-color-muted", "--gemforge-text-muted", "--wn-muted"]],
  ["backgroundColor", ["--gem-color-surface", "--gemforge-surface", "--color-background"]],
  ["surfaceAltColor", ["--gem-color-surface-alt", "--gemforge-surface-alt"]],
  ["borderColor", ["--gem-color-border", "--gemforge-border", "--wn-border"]],
  ["borderSubduedColor", ["--gem-color-border-subdued", "--gemforge-border-light"]],
  ["successColor", ["--gem-color-success", "--gemforge-success"]],
  ["warningColor", ["--gem-color-warning", "--gemforge-warning"]],
  ["criticalColor", ["--gem-color-critical", "--gemforge-critical"]],
  ["infoColor", ["--gem-color-info", "--gemforge-info"]],
  ["radiusSm", ["--gem-radius-sm", "--gemforge-radius-sm"]],
  ["radiusMd", ["--gem-radius-md", "--gemforge-radius-md"]],
  ["radiusLg", ["--gem-radius-lg", "--gemforge-radius-lg"]],
  ["fontBody", ["--gem-font-body", "--font-body-family"]],
  ["fontHeading", ["--gem-font-heading", "--font-heading-family"]],
];

export function hydrateThemeFromHost(config: GemSalesConfig): GemSalesConfig {
  const rootStyle = window.getComputedStyle(document.documentElement);
  const theme = { ...config.theme };

  for (const [key, variableNames] of TOKEN_SOURCES) {
    const detected = readFirstCssVariable(rootStyle, variableNames);
    if (detected) theme[key] = detected;
  }

  return {
    ...config,
    theme: {
      ...theme,
      primaryHoverColor: theme.primaryHoverColor || theme.primaryColor,
      primaryTintColor: theme.primaryTintColor || theme.surfaceAltColor,
      borderSubduedColor: theme.borderSubduedColor || theme.borderColor,
    },
  };
}

function readFirstCssVariable(style: CSSStyleDeclaration, variableNames: string[]): string | null {
  for (const variableName of variableNames) {
    const raw = style.getPropertyValue(variableName).trim();
    if (raw) return raw;
  }

  return null;
}
